import { render, staticRenderFns } from "./ServiceDetailTabsSignatures.vue?vue&type=template&id=c54543e0&scoped=true&"
import script from "./ServiceDetailTabsSignatures.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabsSignatures.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailTabsSignatures.vue?vue&type=style&index=0&id=c54543e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54543e0",
  null
  
)

export default component.exports